import Box from "@mui/material/Box";

type APComparisonColumnHighlightProps = {
  color: "tertiaryGreen.main" | "neutralGray.light";
  leftOffset: number;
  itemWidth: number;
  zIndex: number;
};

const APComparisonColumnHighlight = ({
  color,
  leftOffset,
  itemWidth,
  zIndex,
}: APComparisonColumnHighlightProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        borderRadius: "10px",
        left: `${leftOffset}px`,
        width: {
          xs: `${itemWidth}px`,
        },
        backgroundColor: color,
        opacity: color === "tertiaryGreen.main" ? 0.05 : 0.45,
        zIndex,
        pointerEvents: "none",
      }}
    />
  );
};

export default APComparisonColumnHighlight;
